// src/components/hr/SelectPayrollRunModal.jsx
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  CircularProgress,
} from "@mui/material";
import { useEffect, useState } from "react";
import { graphqlQuery } from "../../../data/Axios/DynamicService";
import { HRService } from "../../../config";
import { ClosedPostedPayrollRuns } from "../../../data/DynamicTable/HorizontalTabComponents";
import { AllClosedPostedPayrollQuery } from "../../../data/Queries/HRmanagement/leavemanagement";

const hr_url = HRService.uri;

// ---------------------------------------------------------------------
// GraphQL to fetch **all** payroll runs (adjust the query name if yours differs)
// ---------------------------------------------------------------------
const payrollRunsQuery = `
  query PayrollRun {
    payrollRun {
       id
        companyId
        countryId
        periodName
        periodStart
        periodEnd
        payDate
        runType
        status
        totalEmployees
        totalGross
        totalNet
        createdBy
        createdAt
        approvedBy
        approvedAt
    }
  }
`;

export default function SelectPayrollRunModal({
  open,
  onClose,
  employeeId,
  onPayrollSelected,   // (payrollRunId) => void
}) {
  const [runs, setRuns] = useState([]);
  const [selectedRunId, setSelectedRunId] = useState("");
  const [loading, setLoading] = useState(true);

  // -------------------------------------------------
  // Load payroll runs once when the modal opens
  // -------------------------------------------------


  
  useEffect(() => {
    if (!open) return;
    (async () => {
      try {
        setLoading(true);
        const resp = await graphqlQuery(AllClosedPostedPayrollQuery, hr_url);
        setRuns(resp ?? []);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    })();
  }, [open]);

  const handleSubmit = () => {
    if (!selectedRunId) return;
    onPayrollSelected(selectedRunId);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Select Payroll Run</DialogTitle>

      <DialogContent dividers>
        <FormControl fullWidth variant="outlined">
          <InputLabel>Payroll Run *</InputLabel>
          <Select
            label="Payroll Run *"
            value={selectedRunId}
            onChange={(e) => setSelectedRunId(e.target.value)}
            disabled={loading}
          >
            {loading && (
              <MenuItem disabled>
                <CircularProgress size={20} />
              </MenuItem>
            )}
            {runs.map((r) => (
              <MenuItem key={r.id} value={r.id}>
                ({r.periodName})
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          disabled={!selectedRunId || loading}
        >
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
}